<template>
  <v-layout align-start>
    <!-- Confirm Dialog -->
    <v-dialog v-model="confirmDialog" max-width="450">
      <v-card class="py-3">
        <v-card-title class="headline"> Confirmación de Folio </v-card-title>
        <v-card-text class="subtitle-1">
          Esta acción es irreversible. Si selecciona continuar, se creará su
          folio.
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn color="primary" outlined @click="confirmDialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="generarFoliosUsuario">
            Continuar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex>
      <!--Tabla para los folios -->
      <v-data-table
        :headers="headersPagos"
        :items="pagos"
        :search="search"
        class="elevation-1"
        v-if="verTablaFolio == 1"
        no-data-text="No hay datos"
        :items-per-page="15"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Pagos</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
              outlined
              dense
            ></v-text-field>

            <v-col cols="auto" class="px-1">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="indigo" dark v-bind="attrs" v-on="on">
                    Opciones
                  </v-btn>
                </template>

                <v-card>
                  <v-list>
                    <v-list-item v-if="isAdmin">
                      <v-autocomplete
                        :items="list_proveedor"
                        item-text="nombre"
                        v-model="itemProveedor"
                        label="Proveedor"
                        clearable
                        return-object
                      >
                      </v-autocomplete>
                    </v-list-item>

                    <v-list-item>
                      <v-text-field
                        hide-details
                        type="date"
                        label="Desde"
                        v-model="fechaInicioPago"
                        :max="new Date().toISOString().substr(0, 10)"
                        clearable
                      ></v-text-field>
                    </v-list-item>

                    <v-list-item>
                      <v-text-field
                        hide-details
                        type="date"
                        label="Hasta"
                        v-model="fechaFinPago"
                        :max="new Date().toISOString().substr(0, 10)"
                        clearable
                      ></v-text-field>
                    </v-list-item>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" dark @click="fitrar()"
                        >Filtrar</v-btn
                      >
                    </v-card-actions>
                  </v-list>
                </v-card>
              </v-menu>
            </v-col>
            <v-btn color="green" dark class="ml-1" @click="ExportarExcel()"
              >Descargar</v-btn
            >
            <v-btn
              color="primary"
              dark
              class="ml-1"
              @click="confirmDialog = true"
              v-if="$store.state.usuario.generarFolio == 'True'"
              >GENERAR FOLIOS</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              @click="mostrarNuevo()"
              color="primary"
              dark
              class="ml-3"
              v-if="isAdmin"
              >Nuevo</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetallesFolio(item)">
            tab
          </v-icon>
        </template>
        <template v-slot:[`item.estatus`]="{ item }">
          <v-chip :color="getColorCondicion(item.estatus)" dark>
            <div v-if="item.estatus"><span>Pagado</span></div>
            <div v-else><span>Sin Pagar</span></div>
          </v-chip>
        </template>
      </v-data-table>

      <!--Detalles del folio -->
      <v-container grid-list-sm class="pa-4 white" v-if="verDetFolio == 1">
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="numeroFolio"
              label="Numero Folio"
              readonly
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="fecha"
              label="Fecha de creación"
              readonly
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="numeroCCF"
              label="Número de documento"
              outlined
              :readonly="!isAdmin"
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="fechaDocumento"
              label="Fecha documento"
              outlined
              :readonly="!isAdmin"
              dense
              hide-details
              type="date"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="proveedor"
              label="Proveedor"
              readonly
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="nombreUsuario"
              label="Nombre Usuario"
              readonly
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="banco"
              :items="itemsBanco"
              label="Banco"
              :readonly="!isAdmin"
              outlined
              dense
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="tipoPago"
              :items="itemsTipoPago"
              label="Tipo de pago"
              :readonly="!isAdmin"
              outlined
              dense
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" v-if="tipoPago == 'Número de transferencia'">
            <v-text-field
              v-model="numeroTransferencia"
              label="Número de transferencia"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4" v-if="tipoPago == 'Número de cheque'">
            <v-text-field
              v-model="numeroCheque"
              label="Número de Cheque"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="fechaPago"
              label="Fecha de pago"
              :readonly="!isAdmin"
              type="datetime-local"
              step="1"
              clearable
              hint="click al icono para desplegar el calendario"
              persistent-hint
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="sumas"
              label="Sumas"
              type="number"
              readonly
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="iva"
              :label="ref_iva_renta"
              type="number"
              readonly
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="ventaTotal"
              label="Venta Total"
              type="number"
              readonly
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-textarea
              v-model="modificaciones"
              auto-grow
              label="Últimas modificaciones"
              outlined
              readonly
              hide-details
            >
            </v-textarea>
          </v-col>
          <v-col cols="8" v-if="isAdmin">
            <v-file-input
              v-model="archivo_extra"
              label="Adjuntar archivo"
              outlined
              dense
              hide-details
              multiple
            ></v-file-input>
          </v-col>
          <v-col cols="auto" v-if="isAdmin">
            <v-btn
              @click="actualizar()"
              color="primary"
              dark
              v-if="
                $store.state.usuario.nombre == 'MONICA ZOLORZANO' ||
                'administrador'
              "
              >Actualizar</v-btn
            >
          </v-col>
          <v-col cols="auto" v-if="btn_correo_visible">
            <v-btn
              @click="generarReporte()"
              color="primary"
              class="ml-3"
              :loading="btn_load"
              >Enviar correo
              <v-icon right>far fa-envelope</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              @click="generarReporte(true)"
              color="primary"
              class="ml-3"
              :loading="btn_load"
              >Descargar Informe
              <v-icon right>fas fa-file-download</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto" v-if="btn_telegram_visible">
            <v-btn
              color="primary"
              class="ml-3"
              @click="generarReporteTelegram()"
              :loading="btn_load_telegram"
              >Enviar mensaje
              <v-icon right>fab fa-telegram</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              @click="mostrarResumenProveedor"
              color="primary"
              class="ml-3"
              :loading="btn_load"
              >Ver Resumen
              <v-icon right>far fa-file-alt</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn @click="ocultarNuevo()" color="cancel" class="ml-3"
              >Cerrar</v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" v-if="isAdmin">
            <v-btn icon large @click="eliminarFolio()">
              <v-icon color="red">far fa-trash-alt</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <!--mostrara los numeros de asistencia en tabla-->
      <v-container class="pa-4" v-if="verDetFolio == 1">
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12 x14>
            <v-data-table
              :headers="headerNumasistencias"
              :items="Nums"
              no-data-text="No hay datos"
              dense
              :items-per-page="50"
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="verDetallesNumAsistencias(item)"
                >
                  tab
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <!--Tabla Para los proveedores -->
      <v-data-table
        :headers="headersProveedores"
        :items="tablaProveedor"
        class="elevation-1"
        v-if="verTablaProveedor == 1"
        no-data-text="No hay datos"
        v-model="selected"
        item-key="numeroAsistencia"
        show-select
        dense
        :items-per-page="50"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Proveedores</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="blue"
                  icon
                  outlined
                  @click.stop="ocultarNuevo()"
                  v-bind="attrs"
                  v-on="on"
                  ><i class="fas fa-arrow-left fa-2x"></i
                ></v-btn>
              </template>
              <span>Regresar</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="indigo" dark v-bind="attrs" v-on="on">
                    Opciones
                  </v-btn>
                </template>
                <v-card>
                  <v-list>
                    <v-list-item>
                      <v-autocomplete
                        :items="list_proveedor"
                        item-text="nombre"
                        v-model="itemProveedor"
                        hide-details
                        label="Proveedor"
                        return-object
                      >
                      </v-autocomplete>
                    </v-list-item>
                    <v-list-item>
                      <v-text-field
                        hide-details
                        type="date"
                        v-model="fechaInicioProveedores"
                        :max="new Date().toISOString().substr(0, 10)"
                      ></v-text-field>
                    </v-list-item>
                    <v-list-item>
                      <v-text-field
                        hide-details
                        type="date"
                        v-model="fechaFinProveedores"
                        :max="new Date().toISOString().substr(0, 10)"
                      ></v-text-field>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </v-col>
            <v-card class="ml-3">
              <v-btn @click="buscar()" dark color="blue">Buscar</v-btn>
            </v-card>
            <v-spacer></v-spacer>
            <v-btn color="blue" class="ml-3" dark @click.stop="AbrirDialog()"
              >Guardar</v-btn
            >
          </v-toolbar>
        </template>
      </v-data-table>

      <v-snackbar v-model="snackValidacion" color="cyan darken-2" right top
        >Los campos de Fecha y proveedor no deben de estar vacias.</v-snackbar
      >
      <v-snackbar v-model="snackValidacionExcel" color="cyan darken-2" right top
        >No hay datos que descargar.</v-snackbar
      >

      <v-snackbar v-model="snackbar" color="primary" right top>
        {{ snackbar_text }}
      </v-snackbar>

      <!-- RESUMEN PROVEEDOR-AJUSTADOR -->
      <v-dialog v-model="dialogResumenProv" max-width="600px">
        <v-card>
          <v-card-title>PROVEEDOR: {{ this.proveedor }} </v-card-title>
          <v-card-subtitle class="px-6">
            De {{ this.resumenProv.desde }} a {{ this.resumenProv.hasta }}.
          </v-card-subtitle>
          <v-card-text>
            <v-list>
              <v-list-item
                v-for="cliente in resumenProv.clientes"
                :key="cliente.nombre"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title class="font-weight-bold">{{
                    cliente.nombre
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-list dense class="py-0">
                      <v-list-item
                        v-for="servicio in cliente.servicios"
                        :key="servicio.tipoServicio"
                      >
                        <v-list-item-content class="py-0">
                          <v-row>
                            <v-col cols="6" class="subtitle-2 py-0 my-0">
                              {{ servicio.tipoServicio }}
                            </v-col>
                            <v-col
                              cols="6"
                              class="subtitle-2 py-0 my-0 text-right"
                            >
                              $ {{ formatNumber(servicio.costo) }}
                            </v-col>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-row class="text-right px-4">
                    <v-col
                      cols="8"
                      class="subtitle-2 font-weight-bold py-0 my-0"
                    >
                      TOTAL:
                    </v-col>
                    <v-col
                      cols="4"
                      class="subtitle-2 font-weight-bold py-0 my-0"
                    >
                      $
                      {{
                        resumenProv.total > 0
                          ? formatNumber(resumenProv.total)
                          : 0
                      }}
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions class="pb-4 px-6">
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outlined
              @click="dialogResumenProv = false"
            >
              Cerrar
            </v-btn>
            <v-btn color="primary" dark @click="downloadResumen">
              Descargar
              <v-icon right dark> fas fa-file-download</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog para nuevo folio-->
      <v-dialog v-model="dialogNuevo" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Datos</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="numeroCCF"
                    label="Numero de CCF"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="itemProveedor.nombre"
                    label="Proveedor"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="nombreUsuario"
                    label="Nombre Usuario"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="sumas"
                    label="Sumas"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="iva"
                    :label="ref_iva_renta"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="ventaTotal"
                    label="Venta Total"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogNuevo = false">
              Cerrar
            </v-btn>
            <v-btn color="blue darken-1" text @click="crear()"> Guardar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog full screen para detalles de cada asistencia -->
      <v-dialog
        v-model="dialogNumAsistencia"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialogNumAsistencia = false">
              <i class="fas fa-times fa-2x"></i>
            </v-btn>
            <v-toolbar-title>Detalles de la asistencia</v-toolbar-title>
          </v-toolbar>
          <!--Contenedor para cliente -->
          <v-container>
            <v-card
              outlined
              width="100%"
              class="pa-2"
              elevation="1"
              style="border: 1px solid black"
            >
              <v-card-title class="pa-0">Datos del Cliente</v-card-title>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="placa"
                    label="Placa"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="polizaBase"
                    label="Poliza"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="marcaBase"
                    label="Marca"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="modeloBase"
                    label="Modelo"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    type="number"
                    v-model="añoBase"
                    label="Año"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="color"
                    label="Color"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="usoBase"
                    label="Uso"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="titularPolizaBase"
                    label="Ttular Poliza"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="nombreConductor"
                    label="Nombre conductor"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="numeroTelefono"
                    label="Numero Telefono"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="cartera" label="Cartera" readonly>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
          <!--Contenedor para datos del servicio -->
          <v-container class="mt-1">
            <v-card
              outlined
              width="100%"
              class="pa-2"
              elevation="1"
              style="border: 1px solid black"
            >
              <v-card-title class="pa-0">Datos del servicio</v-card-title>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="fechaHoraOcurrencia"
                    label="Fecha Ocurrencia"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="proveedor" label="Proveedor" readonly>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="fechaHoraAsignacion"
                    label="Fecha Asignacion"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="align-self-center">
                  <v-text-field v-model="pais" label="Pais" readonly>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="align-self-center">
                  <v-text-field
                    v-model="depaSiniestro"
                    label="Departamento Siniestro"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="align-self-center">
                  <v-text-field
                    v-model="muniSiniestro"
                    label="Municipio Siniestro"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-textarea
                    v-model="comDireccionSiniestro"
                    label="Complemento Direccion Siniestro"
                    readonly
                    auto-grow
                    row-height="0"
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="tipoAsistencia"
                    label="Tipo De Asistencia"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-text-field v-model="causa" label="Causa" readonly>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="atiende" label="Atiende" readonly>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-text-field
                    v-model="depaOrigen"
                    label="Departamento Origen"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-text-field
                    v-model="muniOrigen"
                    label="Municipio Origen"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-textarea
                    v-model="comDireccionOrigen"
                    label="Complemento Direccion Origen"
                    readonly
                    auto-grow
                    row-height="0"
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-text-field
                    v-model="depaDestino"
                    label="Departamento Destino"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-text-field
                    v-model="muniDestino"
                    label="Municipio Destino"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-textarea
                    v-model="comDireccionDestino"
                    label="Complemento Direccion Destino"
                    readonly
                    auto-grow
                    row-height="0"
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="placaContraparte"
                    label="Placa Contraparte"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
          <!-- Contenedor para finalizacion del servicio -->
          <v-container class="my-1">
            <v-card
              outlined
              width="100%"
              class="pa-2"
              elevation="1"
              style="border: 1px solid black"
            >
              <v-card-title class="pa-0"
                >Finalización del servicio</v-card-title
              >
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="costoServicio"
                    label="Costo Servicio"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="mb-6 align-self-center">
                  <v-text-field
                    v-model="tipoServicio"
                    label="Tipo Servicio"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="mb-6 align-self-center">
                  <v-text-field
                    v-model="estatusAsistencia"
                    label="Estatus Asistencia"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-text-field
                    v-model="fechaHoraContacto"
                    label="Fecha Contacto"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-text-field
                    v-model="termino"
                    label="Termino"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-textarea
                    v-model="obsAdicionales"
                    label="Observaciones Adicionales"
                    readonly
                    auto-grow
                    row-height="0"
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="operador" label="Operador" readonly>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="numeroSiniestroQualitas"
                    label="Numero Siniestro Qualitas"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="numeroSpoolerQualitas"
                    label="Numero Spooler Qualitas"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="localForaneo"
                    label="Local/Foraneo"
                    readonly
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="partePolicial"
                    label="Hay Parte Policial?"
                    readonly
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="seMovioDelLugar"
                    label="Se Movio Del lugar"
                    readonly
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="zonaPeligrosa"
                    label="zona Peligrosa"
                    readonly
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="reporteTardio"
                    label="Reporte Tardio"
                    readonly
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="roboRecuperado"
                    label="Robo Recuperado"
                    readonly
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="recupero"
                    label="Recupero Tercero"
                    readonly
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="recupero">
                  <v-text-field
                    v-model="cantRecupero"
                    label="Recupero Tercero"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="estadoEbriedad"
                    label="Estado de ebriedad"
                    readonly
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="fechaHoraCierreAsistencia"
                    label="Fecha Cierre Asistencia"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>
          </v-container>

          <v-overlay v-model="overlay" z-index="0">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-dialog>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
import moment from "moment";

export default {
  data() {
    return {
      confirmDialog: false,
      dialogResumenProv: false,
      resumenProv: [],
      search: "",
      pagos: [],
      proveedores: [],
      tablaProveedor: [],
      selected: [],
      Nums: [],
      responseDepurado: [],
      list_proveedor: [],
      itemProveedor: "",
      headersPagos: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Numero Folio",
          value: "numeroFolio",
          sortable: true,
        },
        { text: "Fecha", value: "fecha", sortable: true },
        { text: "Proveedor", value: "proveedor", sortable: true },
        { text: "Numero CCF", value: "numeroCCF", sortable: true },
        { text: "Nombre Usuario", value: "nombreUsuario", sortable: true },
        { text: "Estatus", align: "left", value: "estatus", sortable: true },
      ],
      headersProveedores: [
        {
          text: "Numero Asistencia",
          align: "left",
          value: "numeroAsistencia",
          sortable: true,
        },
        {
          text: "Fecha Asistencia",
          align: "left",
          value: "fechaHoraActual",
          sortable: true,
        },
        {
          text: "Cartera",
          align: "left",
          value: "cartera",
          sortable: true,
        },
        {
          text: "Proveedor",
          align: "left",
          value: "proveedor",
          sortable: true,
        },
        {
          text: "Tipo Asistencia",
          align: "left",
          value: "tipoAsistencia",
          sortable: true,
        },
      ],
      headerNumasistencias: [
        { text: "Opciones", align: "left", value: "action", sortable: false },
        {
          text: "Fecha",
          value: "fechaHoraActual",
        },
        {
          text: "Numero Asistencia",
          align: "left",
          value: "numeroAsistencia",
          sortable: true,
        },
      ],
      menu: false,
      fechaInicioPago: "",
      fechaFinPago: "",
      fechaInicioProveedores: "",
      fechaFinProveedores: "",
      idPagosProveedores: "",
      idCabina: "",
      numeroFolio: "",
      fecha: "",
      numeroCCF: "",
      fechaDocumento: "",
      proveedor: "",
      nombreUsuario: "",
      asistencias: "",
      sumas: 0,
      iva: 0,
      ventaTotal: 0,
      totalCostos: 0,
      totalCostosIva: 0,
      ventaTotalSuma: 0,
      sumaCosto: 0,
      banco: "",
      itemsBanco: ["Banco Agrícola", "América Central"],
      fechaPago: "",
      estatus: 0,
      tipoPago: "",
      itemsTipoPago: ["Número de cheque", "Número de transferencia"],
      numeroCheque: "",
      numeroTransferencia: "",
      modificaciones: "",
      fechaModificacion: "",
      verTablaFolio: 1,
      verDetFolio: 0,
      verTablaProveedor: 0,
      verDetProveedor: 0,
      validaMensaje: "",
      overlay: false,
      snackValidacion: false,
      snackValidacionExcel: false,
      dialogNuevo: false,
      dialogNumAsistencia: false,
      archivo_extra: [],
      //variables para ver los detalles de cada asistencia
      fechaHoraActual: "",
      fechaHoraOcurrencia: "",
      cartera: "",
      numeroAsistencia: "",
      numeroTelefono: "",
      placa: "",
      polizaBase: "",
      marcaBase: "",
      modeloBase: "",
      añoBase: 0,
      usoBase: "",
      titularPolizaBase: "",
      estatusBase: "",
      color: "",
      nombreConductor: "",
      pais: "",
      depaSiniestro: "",
      muniSiniestro: "",
      comDireccionSiniestro: "",
      causa: "",
      tipoServicio: "",
      proveedor: "",
      atiende: "",
      fechaHoraAsignacion: "",
      depaOrigen: "",
      muniOrigen: "",
      comDireccionOrigen: "",
      depaDestino: "",
      muniDestino: "",
      comDireccionDestino: "",
      fechaHoraContacto: "",
      costoServicio: 0,
      fechaHoraCierreAsistencia: "",
      placaContraparte: "",
      partePolicial: false,
      obsAdicionales: "",
      tipoAsistencia: "",
      numeroSiniestroQualitas: "",
      numeroSpoolerQualitas: "",
      seMovioDelLugar: false,
      zonaPeligrosa: false,
      reporteTardio: false,
      roboRecuperado: false,
      localForaneo: "",
      operador: "",
      estatusAsistencia: "",
      termino: "",
      cantRecupero: "",
      recupero: false,
      estadoEbriedad: false,
      btn_load: false,
      btn_load_telegram: false,
      snackbar: false,
      snackbar_text: "",
      id_telegram: "",
      correo: "",
      isSelecting: false,
      btn_correo_visible: false,
      btn_telegram_visible: false,
      ref_iva_renta: "",
      flag: 1,
      proveedor_pais: "",
    };
  },
  created() {
    const today = new Date();
    const firstDayInMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.fechaInicioPago = firstDayInMonth.toISOString().substring(0, 10);
    this.fechaFinPago = today.toISOString().substring(0, 10);

    this.getProveedores();
    this.listar();
  },
  computed: {
    isAdmin() {
      return (
        this.$store.state.usuario.rol == "Administrador" ||
        this.$store.state.usuario.rol == "Admin Proveedores"
      );
    },
  },
  methods: {
    generarFoliosUsuario() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          `api/Cabinas/Folios/${this.$store.state.usuario.nombre}`,
          configuracion
        )
        .then((res) => {
          if (res.status == 204) {
            this.snackbar_text = "No Hay Folios para Generar!";
            this.snackbar = true;
          }

          if (res.status == 200) {
            this.snackbar_text = "Folio Generado Correctamente!";
            this.snackbar = true;
          }
          this.listar();
        })
        .catch((err) => {
          console.error(err);
          this.snackbar_text = "No se Pudo Generar el Folio!";
          this.snackbar = true;
        })
        .finally(() => {
          this.confirmDialog = false;
        });
    },
    formatNumber(number) {
      if (number == 0) return "0.00";
      if (!number) return "0.00";

      const formatter = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
      });
      return formatter.format(number);
    },
    mostrarResumenProveedor() {
      this.dialogResumenProv = true;
    },
    getResumenProveedor(proveedorId) {
      if (!proveedorId) return;

      const numerosAsistencia = this.Nums.map((n) =>
        Number(n.numeroAsistencia)
      );

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/PagoProveedores/ReporteIncentivos",
          {
            proveedorId: proveedorId,
            numerosAsistencia: numerosAsistencia,
          },
          configuracion
        )
        .then((res) => {
          this.resumenProv = res.data;
        })
        .catch((err) => console.log(err.res));
    },
    downloadResumen() {
      const clientes = this.resumenProv.clientes;
      const listado = [];

      clientes.forEach((cliente) => {
        cliente.servicios.forEach((servicio) => {
          listado.push({
            Cliente: cliente.nombre,
            TipoServicio: servicio.tipoServicio,
            Costo: this.formatNumber(servicio.costo),
          });
        });
      });

      listado.push({
        Cliente: "",
        TipoServicio: "TOTAL",
        Costo: this.formatNumber(this.resumenProv.total),
      });

      listado.push({
        Cliente: "",
        TipoServicio: "",
        Costo: "",
      });

      listado.push({
        Cliente: "Proveedor",
        TipoServicio: this.resumenProv.proveedor,
        Costo: "",
      });

      const data = XLSX.utils.json_to_sheet(listado);
      const workbook = XLSX.utils.book_new();

      data["!merges"] = [];
      let currentRow = 1;
      clientes.forEach((cliente) => {
        const serviciosLength = cliente.servicios.length;

        data["!merges"].push({
          s: { r: currentRow, c: 0 },
          e: { r: currentRow + serviciosLength - 1, c: 0 },
        });

        currentRow += serviciosLength;
      });

      XLSX.utils.book_append_sheet(workbook, data, "Resumen");

      const filename = `Resumen ${this.resumenProv.proveedor} (${this.resumenProv.desde} a ${this.resumenProv.hasta}) .xlsx`;
      XLSX.writeFile(workbook, filename);
    },
    eliminarFolio() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .delete(
          "api/PagoProveedores/DeletePagosProveedores/" +
            this.idPagosProveedores,
          configuracion
        )
        .then(() => {
          this.ocultarNuevo();
          this.listar();
          this.alerta("Folio eliminado");
        })
        .catch(() => {
          this.alerta("No se pudo eliminar el folio");
        });
    },
    alerta(mensaje) {
      this.$toast.info(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 5000,
      });
    },
    mostrarNuevo() {
      this.flag = 1;
      this.verTablaFolio = 0;
      this.verTablaProveedor = 1;
    },
    ocultarNuevo() {
      this.verTablaFolio = 1;
      this.verTablaProveedor = 0;
      this.verDetFolio = 0;
      this.limpiar();
    },
    getColorCondicion(condicion) {
      if (condicion == true) {
        return "green";
      } else {
        return "red";
      }
    },
    getProveedores() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/DetallexProveedores/Listar", configuracion)
        .then(function (response) {
          const list_proveedores = response.data;
          list_proveedores.forEach((element, index) => {
            me.list_proveedor.push({
              idProveedor: element.idProveedor,
              nombre: element.nombre,
              idTelegram: element.chatIdTelegram,
              correo: element.correo,
              ncr: element.ncr,
              nacional: element.nacional,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listar() {
      this.overlay = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/PagoProveedores/RangoFechas?fechaInicio=${this.fechaInicioPago}&fechaFin=${this.fechaFinPago}`,
          configuracion
        )
        .then((response) => {
          this.pagos = [];
          this.pagos = response.data;
          if (response.status == 200) {
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.overlay = false;
        });
    },
    formatPagosRango() {
      const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toISOString().split("T")[0];
      };

      const folios = this.pagos.map((data) => {
        const esIva = Number(data.sumas) < Number(data.ventaTotal);

        const folio = {
          "FECHA DOCUMENTO": formatDate(data.fechaDocumento),
          PROVEEDOR: data.proveedor,
          SUMA: this.formatNumber(data.sumas),
          "TOTAL (IVA)": esIva
            ? this.formatNumber(data.iva)
            : this.formatNumber(0.0),
          "TOTAL (RENTA)": !esIva
            ? this.formatNumber(data.iva)
            : this.formatNumber(0.0),
          "VENTA TOTAL": this.formatNumber(data.ventaTotal),
          "NUMERO DE DOCUMENTO": data.numeroCCF,
          FOLIO: data.numeroFolio,
        };

        return folio;
      });

      return folios;
    },
    verificarRentaIvaProveedor(proveedor) {
      if (!proveedor) return 0;
      if (proveedor.ncr && proveedor.nacional) return 0.13;
      else if (!proveedor.ncr && proveedor.nacional) return 0.1;
      else return 0;
    },
    //filtrar folio
    fitrar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (me.fechaInicioPago && me.fechaFinPago && me.itemProveedor) {
        me.overlay = true;
        axios
          .get(
            "api/PagoProveedores/FiltrarFolio/" +
              me.fechaInicioPago +
              "/" +
              me.fechaFinPago +
              "/" +
              me.itemProveedor.nombre,
            configuracion
          )
          .then(function (response) {
            me.pagos = [];
            me.pagos = response.data;
            me.pagos.forEach((element, index) => {
              me.responseDepurado.push({
                "Fecha documento": me.formatoFecha(element.fechaDocumento),
                Proveedor: element.proveedor,
                Sumas: element.sumas,
                "Venta total": element.ventaTotal,
                "Numero de documento": element.numeroCCF,
                "Numero de folio": element.numeroFolio,

                /*Fecha: element.fecha,
                "Nombre de usuario": element.nombreUsuario,
                Banco: element.banco,
                "Fecha de pago": element.fechaPago,
                "Tipo de pago": element.tipoPago,
                Asistencias: element.asistencias,
                Iva: element.iva,*/
              });
            });
            if (response.status == 200) {
              me.overlay = false;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.listar();
      }
    },
    //Buscar por proveedores
    buscar() {
      let me = this;
      let splitAsistencias = [];
      let numAsistencias = [];
      me.tablaProveedor = [];
      let bandera = false;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (
        me.itemProveedor != "" &&
        me.fechaInicioProveedores != "" &&
        me.fechaFinProveedores != ""
      ) {
        me.overlay = true;
        axios
          .get(
            "api/Cabinas/DetallexProveedor/" +
              me.fechaInicioProveedores +
              "/" +
              me.fechaFinProveedores +
              "/" +
              me.itemProveedor.idProveedor,
            configuracion
          )
          .then(function (response) {
            me.proveedores = response.data;
            //me.pagos tiene los folios ya creados
            me.pagos.forEach((element, index) => {
              if (me.itemProveedor.nombre == element.proveedor) {
                const stringNumAsistencia = element.asistencias.split("-");
                for (var i = 0; i < stringNumAsistencia.length - 1; i++) {
                  splitAsistencias.push(stringNumAsistencia[i]);
                }
              }
            });
            //me.proveedores tiene las asistencias que estan en cabina
            me.proveedores.forEach((element, index) => {
              numAsistencias.push(element.numeroAsistencia);
            });

            for (let i = 0; i <= numAsistencias.length - 1; i++) {
              for (let j = 0; j <= splitAsistencias.length - 1; j++) {
                if (numAsistencias[i] == splitAsistencias[j]) {
                  bandera = true;
                }
              }
              if (bandera == false) {
                me.tablaProveedor.push(me.proveedores[i]);
              }
              bandera = false;
            }
            if (response.status == 200) {
              me.overlay = false;
            }
          })
          .catch(function () {
            me.overlay = false;
          });
      }
    },
    //Crear Folio
    crear() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let numeroDeAsistencias = "";
      //guardamos los numero de asistencia en una variable
      me.selected.forEach(
        (element) => (numeroDeAsistencias += element.numeroAsistencia + "-")
      );
      axios
        .post(
          "api/PagoProveedores/Crear",
          {
            idCabina: me.proveedores[0].idCabina,
            numeroCCF: me.numeroCCF,
            fechaDocumento: me.fechaDocumento,
            nombreUsuario: me.$store.state.usuario.nombre,
            asistencias: numeroDeAsistencias,
            proveedor: me.itemProveedor.nombre,
            banco: me.banco,
            //aqui seria si fuera numero de cheque o numero de transferencia
            tipoPago: me.tipoPago,
            fechaPago: me.fechaPago,
            estatus: me.estatus,
            sumas: me.sumas,
            iva: me.iva,
            ventaTotal: me.ventaTotal,
            modificaciones: me.modificaciones,
          },
          configuracion
        )
        .then(function (response) {
          me.ocultarNuevo();
          me.listar();
          me.dialogNuevo = false;
          me.tablaProveedor = [];
          me.Nums = [];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    actualizar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      const metodoPago = me.verificarTipoPago();
      const updateEstatus = me.verificarEstatus();
      const today = new Date();
      const fecha =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const hora =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      me.fechaModificacion = fecha + " " + hora;
      if (me.modificaciones != "") {
        var fechaModificacion = me.modificaciones + "/" + me.fechaModificacion;
      } else {
        var fechaModificacion = me.fechaModificacion;
      }

      axios
        .put(
          "api/PagoProveedores/Actualizar",
          {
            idPagoProveedores: me.idPagosProveedores,
            idCabina: me.idCabina,
            fecha: me.fecha,
            numeroCCF: me.numeroCCF,
            fechaDocumento: me.fechaDocumento,
            nombreUsuario: me.nombreUsuario,
            asistencias: me.asistencias,
            proveedor: me.proveedor,
            banco: me.banco,
            fechaPago: me.fechaPago,
            tipoPago: metodoPago,
            estatus: updateEstatus,
            sumas: me.sumas,
            iva: me.iva,
            ventaTotal: me.ventaTotal,
            modificaciones: fechaModificacion,
          },
          configuracion
        )
        .then(function (response) {
          me.listar();
          me.ocultarNuevo();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verDetallesFolio(item) {
      this.limpiar();
      this.flag = 2;
      const updateTipoPago = this.verificarDetalles(item);
      let arrayNumAsistencias = [];
      let contador = 0;
      this.idPagosProveedores = item.idPagoProveedores;
      this.idCabina = item.idCabina;
      this.numeroFolio = item.numeroFolio;
      this.fecha = item.fecha;
      this.numeroCCF = item.numeroCCF;
      this.fechaDocumento = this.formatoFecha(item.fechaDocumento);
      this.proveedor = item.proveedor;
      this.nombreUsuario = item.nombreUsuario;
      this.asistencias = item.asistencias;
      this.banco = item.banco;
      this.fechaPago = item.fechaPago;
      this.tipoPago = updateTipoPago;
      this.estatus = item.estatus;

      this.verDetallesProveedor(item.idCabina);

      const cantModificaiones = item.modificaciones.split("/");
      cantModificaiones.forEach((element, index) => {
        if (element != "") {
          this.modificaciones = this.modificaciones + element + "\n";
        }
      });
      this.verTablaFolio = 0;
      this.verDetFolio = 1;

      arrayNumAsistencias = this.asistencias.split("-");
      contador = arrayNumAsistencias.length;
      arrayNumAsistencias.forEach((element, index) => {
        if (contador - 1 != index) {
          this.Nums.push({
            numeroAsistencia: element,
          });
          this.peticionCosto(element);
        }
      });

      this.detallesProveedor(item.idProveedor);
      this.getResumenProveedor(item.idProveedor);
    },
    detallesProveedor(id_proveedor) {
      //console.log("detallesProveedor", id_proveedor);

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/DetallexProveedores/ListarId/" + id_proveedor, configuracion)
        .then((response) => {
          if ((this.flag = 2)) {
            this.itemProveedor = response.data;
          }
          //console.log(response.data);
          //NO POSEE NCR Y ES NACIONAL
          if (
            (response.data[0].ncr == null || !response.data[0].ncr) &&
            response.data[0].nacional
          ) {
            //console.log("NO NCR, SI NACIONAL");
            this.ref_iva_renta = "RENTA";
          }
          //POSEE NCR Y ES NACIONAL
          if (response.data[0].ncr && response.data[0].nacional) {
            //console.log("SI NCR, SI NACIONAL");
            this.ref_iva_renta = "IVA";
          }
        });
    },
    verDetallesProveedor(id) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/PagoProveedores/DetallesProveedor/" + id, configuracion)
        .then((response) => {
          //console.log(response.data);
          this.id_telegram = response.data.chatIdTelegram;
          this.correo = response.data.correo;
          this.btn_correo_visible = response.data.correo != null ? true : false;
          this.btn_telegram_visible =
            response.data.chatIdTelegram != null ? true : false;
          this.proveedor_nacional = response.data.nacional;
          this.proveedor_pais = response.data.tipoProveedor;
        });
    },
    //calculo para sacar costos, iva y venta total
    peticionCosto(element) {
      //console.log("PETICION COSTO", element);
      let me = this;
      let arrayCostos = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      //element posee el numero de asistencia
      axios
        .get("api/Cabinas/Costos/" + element, configuracion)
        .then(function (response) {
          //console.log("RESPONSE DATA", response.data);
          //console.log(me.itemProveedor);
          arrayCostos = response.data;
          arrayCostos.forEach((element, index) => {
            me.sumaCosto = me.sumaCosto + element.costoServicio;
            me.totalCostos = me.sumaCosto.toFixed(2);

            //ESTA CONDICION ES PARA CUANDO SE VA A CREAR UN NUEVO FOLIO
            if (me.flag == 1) {
              //NO POSEE NCR Y ES NACIONAL
              if (
                (me.itemProveedor.ncr == null || me.itemProveedor.ncr == "") &&
                me.itemProveedor.nacional
              ) {
                //console.log("NO NCR, SI NACIONAL");
                me.totalCostosIva = Number((me.sumaCosto * 0.1).toFixed(2));
                me.ventaTotalSuma = (me.sumaCosto - me.totalCostosIva).toFixed(
                  2
                );
                me.ref_iva_renta = "RENTA";
              }
              //POSEE NCR Y ES NACIONAL
              if (me.itemProveedor.ncr && me.itemProveedor.nacional) {
                //console.log("SI NCR, SI NACIONAL");
                me.totalCostosIva = Number((me.sumaCosto * 0.13).toFixed(2));
                me.ventaTotalSuma = (me.sumaCosto + me.totalCostosIva).toFixed(
                  2
                );
                me.ref_iva_renta = "IVA";
              }

              //ES INTERNACIONA
              if (!me.itemProveedor.nacional) {
                //console.log("INTERNACIONAL");
                me.totalCostosIva = 0;
                me.ventaTotalSuma = (me.sumaCosto + me.totalCostosIva).toFixed(
                  2
                );
              }
              //ESTA CONDICION ES PARA EL FOLIO YA ESTA CREADO
            } else if (me.flag == 2) {
              //NO POSEE NCR Y ES NACIONAL
              if (
                (me.itemProveedor[0].ncr == null ||
                  me.itemProveedor[0].ncr == "") &&
                me.itemProveedor[0].nacional
              ) {
                //console.log("NO NCR, SI NACIONAL");
                me.totalCostosIva = Number((me.sumaCosto * 0.1).toFixed(2));
                me.ventaTotalSuma = (me.sumaCosto - me.totalCostosIva).toFixed(
                  2
                );
                me.ref_iva_renta = "RENTA";
              }
              //POSEE NCR Y ES NACIONAL
              if (me.itemProveedor[0].ncr && me.itemProveedor[0].nacional) {
                //console.log("SI NCR, SI NACIONAL");
                me.totalCostosIva = Number((me.sumaCosto * 0.13).toFixed(2));
                me.ventaTotalSuma = (me.sumaCosto + me.totalCostosIva).toFixed(
                  2
                );
                me.ref_iva_renta = "IVA";
              }

              //ES INTERNACIONA
              if (!me.itemProveedor[0].nacional) {
                //console.log("INTERNACIONAL");
                me.totalCostosIva = 0;
                me.ventaTotalSuma = (me.sumaCosto + me.totalCostosIva).toFixed(
                  2
                );
              }
            }
          });

          me.asignarCostos(
            me.totalCostos,
            me.totalCostosIva,
            me.ventaTotalSuma
          );

          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    asignarCostos(suma, iva, ventaTotal) {
      this.sumas = suma;
      this.iva = iva;
      this.ventaTotal = ventaTotal;
    },
    verDetallesNumAsistencias(item) {
      let me = this;
      me.overlay = true;
      me.dialogNumAsistencia = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Cabinas/DetallexNumAsistencia/" + item.numeroAsistencia,
          configuracion
        )
        .then(function (response) {
          me.overlay = false;
          me.numeroAsistencia = response.data[0].numeroAsistencia;
          me.fechaHoraActual = response.data[0].fechaHoraActual;
          me.placa = response.data[0].placa;
          me.polizaBase = response.data[0].polizaBase;
          me.marcaBase = response.data[0].marcaBase;
          me.modeloBase = response.data[0].modeloBase;
          me.añoBase = response.data[0].añoBase;
          me.color = response.data[0].color;
          me.usoBase = response.data[0].usoBase;
          me.titularPolizaBase = response.data[0].titularPolizaBase;
          me.nombreConductor = response.data[0].nombreConductor;
          me.numeroTelefono = response.data[0].numeroTelefono;
          me.cartera = response.data[0].cartera;
          me.fechaHoraOcurrencia = response.data[0].fechaHoraOcurrencia;
          me.proveedor = response.data[0].proveedor;
          me.fechaHoraAsignacion = response.data[0].fechaHoraAsignacion;
          me.pais = response.data[0].pais;
          me.depaSiniestro = response.data[0].depaSiniestro;
          me.muniSiniestro = response.data[0].muniSiniestro;
          me.comDireccionSiniestro = response.data[0].comDireccionSiniestro;
          me.tipoAsistencia = response.data[0].tipoAsistencia;
          me.causa = response.data[0].causa;
          me.atiende = response.data[0].atiende;
          me.depaOrigen = response.data[0].depaOrigen;
          me.muniOrigen = response.data[0].muniOrigen;
          me.comDireccionOrigen = response.data[0].comDireccionOrigen;
          me.depaDestino = response.data[0].depaDestino;
          me.muniDestino = response.data[0].muniDestino;
          me.comDireccionDestino = response.data[0].comDireccionDestino;
          me.placaContraparte = response.data[0].placaContraparte;
          me.costoServicio = response.data[0].costoServicio;
          me.tipoServicio = response.data[0].tipoServicio;
          me.estatusAsistencia = response.data[0].estatusAsistencia;
          me.fechaHoraContacto = response.data[0].fechaHoraContacto;
          me.termino = response.data[0].termino;
          me.obsAdicionales = response.data[0].obsAdicionales;
          me.operador = response.data[0].operador;
          me.numeroSiniestroQualitas = response.data[0].numeroSiniestroQualitas;
          me.numeroSpoolerQualitas = response.data[0].numeroSpoolerQualitas;
          me.localForaneo = response.data[0].localForaneo;
          me.partePolicial = response.data[0].partePolicial;
          me.seMovioDelLugar = response.data[0].seMovioDelLugar;
          me.zonaPeligrosa = response.data[0].zonaPeligrosa;
          me.reporteTardio = response.data[0].reporteTardio;
          me.roboRecuperado = response.data[0].roboRecuperado;
          me.recupero = response.data[0].recupero;
          me.estadoEbriedad = response.data[0].estadoEbriedad;
          me.fechaHoraCierreAsistencia =
            response.data[0].fechaHoraCierreAsistencia;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      this.dialogNumAsistencia = false;
      this.idPagosProveedores = "";
      this.idCabina = "";
      this.numeroFolio = "";
      this.fecha = "";
      this.numeroCCF = "";
      this.fechaDocumento = "";
      this.nombreUsuario = "";
      this.proveedor = "";
      (this.asistencias = ""), (this.banco = "");
      this.fechaPago = "";
      this.tipoPago = "";
      this.numeroCheque = "";
      this.numeroTransaccion = "";
      this.estatus = 0;
      (this.sumas = 0), (this.iva = 0), (this.ventaTotal = 0);
      this.totalCostos = 0;
      this.totalCostosIva = 0;
      this.sumaCosto = 0;
      this.sumaCosotoIva = 0;
      this.modificaciones = "";
      //variables del formulario
      (this.fechaHoraActual = ""),
        (this.fechaHoraOcurrencia = ""),
        (this.cartera = ""),
        (this.numeroAsistencia = ""),
        (this.numeroTelefono = ""),
        (this.placa = ""),
        (this.polizaBase = ""),
        (this.marcaBase = ""),
        (this.modeloBase = ""),
        (this.añoBase = 0),
        (this.usoBase = ""),
        (this.titularPolizaBase = ""),
        (this.estatusBase = ""),
        (this.color = ""),
        (this.nombreConductor = ""),
        (this.pais = ""),
        (this.depaSiniestro = ""),
        (this.muniSiniestro = ""),
        (this.comDireccionSiniestro = ""),
        (this.causa = ""),
        (this.tipoServicio = ""),
        (this.proveedor = ""),
        (this.atiende = ""),
        (this.fechaHoraAsignacion = ""),
        (this.depaOrigen = ""),
        (this.muniOrigen = ""),
        (this.comDireccionOrigen = ""),
        (this.depaDestino = ""),
        (this.muniDestino = ""),
        (this.comDireccionDestino = ""),
        (this.fechaHoraContacto = ""),
        (this.costoServicio = 0),
        (this.fechaHoraCierreAsistencia = ""),
        (this.placaContraparte = ""),
        (this.partePolicial = false),
        (this.obsAdicionales = ""),
        (this.tipoAsistencia = ""),
        (this.numeroSiniestroQualitas = ""),
        (this.numeroSpoolerQualitas = ""),
        (this.seMovioDelLugar = false),
        (this.zonaPeligrosa = false),
        (this.reporteTardio = false),
        (this.roboRecuperado = false),
        (this.localForaneo = ""),
        (this.operador = ""),
        (this.estatusAsistencia = ""),
        (this.termino = ""),
        (this.cantRecupero = ""),
        (this.recupero = false),
        (this.estadoEbriedad = false),
        (this.verTablaFolio = 1);
      this.verTablaProveedor = 0;
      this.Nums = [];
      this.selected = [];
      this.itemProveedor = "";
    },
    ExportarExcel() {
      let me = this;
      if (me.responseDepurado.length != 0) {
        let data = XLSX.utils.json_to_sheet(me.responseDepurado);
        const workbook = XLSX.utils.book_new();
        const filename = "Folio";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      } else {
        const pagosOrdenAsc = this.formatPagosRango().toSorted(
          (x, y) =>
            new Date(x["FECHA DOCUMENTO"]) - new Date(y["FECHA DOCUMENTO"])
        );
        let data = XLSX.utils.json_to_sheet(pagosOrdenAsc);
        const workbook = XLSX.utils.book_new();
        const filename = `Folios ${this.fechaInicioPago} a ${this.fechaFinPago}`;

        data["!cols"] = [
          { wch: 18 },
          { wch: 40 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 23 },
          { wch: 12 },
        ];

        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      }
    },
    AbrirDialog() {
      //guardamos os numero de asistencia en un arreglo
      this.Nums = [];
      this.totalCostos = 0;
      this.sumaCosto = 0;

      this.selected.forEach((element, index) => {
        this.Nums.push({
          numeroAsistencia: element.numeroAsistencia,
        });
      });
      //se recorre el arreglo para llamar un metodo que calculara los costos por numero de asistencia
      this.Nums.forEach((element, index) => {
        this.peticionCosto(element.numeroAsistencia);
      });

      if (this.proveedores.length != 0 && this.selected.length != 0) {
        this.nombreUsuario = this.$store.state.usuario.nombre;
        this.dialogNuevo = true;
      } else {
        return (this.snackValidacion = true);
      }
    },
    verificarTipoPago() {
      if (this.tipoPago == "Número de cheque") {
        this.numeroCheque = "C " + this.numeroCheque;
        return this.numeroCheque;
      } else {
        this.numeroTransferencia = "T " + this.numeroTransferencia;
        return this.numeroTransferencia;
      }
    },
    verificarDetalles(dato) {
      if (dato.tipoPago == "" || dato.tipoPago == null) {
        return "";
      }

      const stringTipoPago = dato.tipoPago;
      const splitTipoPago = stringTipoPago.split(" ");
      if (splitTipoPago[0] == "C") {
        this.tipoPago = "Número de cheque";
        this.numeroCheque = splitTipoPago[1];
        return this.tipoPago;
      }
      if (splitTipoPago[0] == "T") {
        this.tipoPago = "Número de transferencia";
        this.numeroTransferencia = splitTipoPago[1];
        return this.tipoPago;
      }
    },
    verificarEstatus() {
      if (this.fechaPago == "" || this.fechaPago == null) {
        return false;
      } else {
        return true;
      }
    },
    async generarReporte(soloInforme) {
      this.btn_load = true;
      var base64_replace = [];
      for (var i = 0; i < this.archivo_extra.length; i++) {
        var base64 = await this.getBase64(i);
        base64_replace.push({
          report_extra: base64.replace("data:", "").replace(/^.+,/, ""),
          report_nombre_extra: this.archivo_extra[i].name,
        });
      }

      let response = null;
      if (soloInforme) {
        response = await axios({
          url: "api/PagoProveedores/GenerarReporte",
          method: "POST",
          data: {
            idPagoProveedores: this.idPagosProveedores,
            nombre_proveedor: this.proveedor,
            correo_proveedor: this.correo,
            archivo_extra: base64_replace,
            ref_iva_renta: this.ref_iva_renta,
            nacional: this.proveedor_nacional,
            pais: this.proveedor_pais,
            sumas: this.sumas,
            iva_renta: this.iva,
            total: this.ventaTotal,
            soloInforme: true,
          },
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
          responseType: "blob",
        }).catch(() => {
          this.btn_load = false;
        });
      } else {
        response = await axios({
          url: "api/PagoProveedores/GenerarReporte",
          method: "POST",
          data: {
            idPagoProveedores: this.idPagosProveedores,
            nombre_proveedor: this.proveedor,
            correo_proveedor: this.correo,
            archivo_extra: base64_replace,
            ref_iva_renta: this.ref_iva_renta,
            nacional: this.proveedor_nacional,
            pais: this.proveedor_pais,
            sumas: this.sumas,
            iva_renta: this.iva,
            total: this.ventaTotal,
            soloInforme: false,
          },
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        }).catch(() => {
          this.btn_load = false;
        });
      }

      this.btn_load = false;
      if (response.status == 200) {
        if (soloInforme) {
          const blob = response.data;
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = `${this.numeroFolio}.pdf`;

          document.body.appendChild(a);
          a.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          this.snackbar_text = "Correo enviado correctamente";
          this.snackbar = true;
        }
      } else {
        this.btn_load = false;
      }
    },
    async generarReporteTelegram() {
      this.btn_load_telegram = true;
      var response = await axios({
        url:
          "api/PagoProveedores/GenerarReporteTelegram/" +
          this.idPagosProveedores +
          "/" +
          this.id_telegram,
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      });

      if (response.status == 200) {
        this.btn_load_telegram = false;
        this.snackbar_text = "Mensaje enviado correctamente";
        this.snackbar = true;
      } else {
        this.btn_load_telegram = false;
        this.snackbar_text = "Mensaje no pudo enviarse";
        this.snackbar = true;
      }

      /*var binaryString = window.atob(response.data);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }

      var blob = new Blob([bytes]);
      var link = document.createElement("a");      
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = this.numeroFolio + "_" + this.proveedor + ".pdf";
      link.click();
      URL.revokeObjectURL(url);*/
    },
    getBase64(index) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(this.archivo_extra[index]);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    formatoFecha(fecha) {
      if (fecha) {
        return moment(fecha).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
  },
};
</script>
